import { graphql, useStaticQuery } from "gatsby"
import Link from "./Link"
import parse from "html-react-parser"
import React, { useEffect, useState } from "react"
import { useFlexSearch } from "react-use-flexsearch"
import { v4 as uuidv4 } from "uuid"
import ImageOpt from "./ImageOpt"

const itemsPerRow = 6

const SearchListing = ({ module }) => {
  const [queryParams, setQueryParams] = useState(null)
  const [searchData, setsearchData] = useState([])

  const [next, setNext] = useState(itemsPerRow)

  const handleMoreItems = () => {
    setNext(next + itemsPerRow)
  }

  let params = {}
  if (typeof window !== "undefined") {
    params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
  }

  useEffect(() => {
    setQueryParams(params.q)
  }, [params, next])

  const query = useStaticQuery(graphql/* GraphQL */ `
    query {
      localSearchPages {
        index
        store
      }
    }
  `)
  const results = useFlexSearch(
    queryParams,
    query.localSearchPages.index,
    query.localSearchPages.store
  )

  useEffect(() => {
    setsearchData(results)
  }, [queryParams])

  useEffect(() => {
    document.querySelector(".search-loader-wrapper__inner").style.opacity = "0"
    setTimeout(() => {
      document.getElementById("search-loader-wrapper").style.display = "none"
      document.querySelector("body").style.overflow = "auto"
    }, 400)
  }, [searchData])

  return (
    <>
      <div
        id="search-loader-wrapper"
        className="search-loader-wrapper fixed z-[99999999999] h-full w-full top-0 left-0"
      >
        <div className="search-loader-wrapper__inner h-full w-full flex flex-col justify-center items-center bg-[#272525]/70 transition-all duration-[400ms] ease-in-out">
          <div className="loader-spinner"></div>
          <p className="loader-text text-15 leading-[24px] text-[#ffffff] font-primary text-center mt-20">
            Searching for the best results, just a moment...
          </p>
        </div>
      </div>
      <section className="banner--wapper">
        <div
          className="h-[88px] smscreen2:h-[89px] opacity-0"
          aria-label="Kova"
        >
          Kove
        </div>
        <div className="banner half-banner relative bg-stone">
          <div className="container-fluid h-full">
            <div className="banner-inner relative h-full">
              <div className="desk-img h-full mdscreen:h-full relative block smscreen2:hidden">
                <ImageOpt
                  imgData="http://cms.kovecollection.co.za/app/uploads/2023/11/SearchResults-scaled.jpg"
                  width={1440}
                  height={700}
                  imgAlt="Search Listing"
                  imgLoad="lazy"
                  imgClass="w-full h-full object-cover"
                />
              </div>
              <div className="mobile-img h-full mdscreen:h-full relative hidden smscreen2:block">
                <ImageOpt
                  imgData="http://cms.kovecollection.co.za/app/uploads/2023/11/SearchResults-scaled.jpg"
                  width={1440}
                  height={700}
                  imgAlt="Search Listing"
                  imgLoad="lazy"
                  imgClass="w-full h-full object-cover"
                />
              </div>
              <div className="absolute bottom-0 pb-120 lgscreen:pb-50 z-10 text-center w-full px-30">
                <div className="preheading mb-10 lgscreen:mb-15">
                  <span className="font-ositalic text-17 text-white-100 ">
                    Search
                  </span>
                </div>
                <div className="title-white">
                  <h1>
                    {results.length} Results for "<i>{queryParams}</i> "
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="simple-content  py-50 lgscreen:py-25">
        <div className="w-full max-w-[980px] lgscreen:px-20 mx-auto text-center">
          <div className="content">
            <p>Explore the links below to find what you may be looking for</p>
          </div>
        </div>
      </section>
      <section
        className={`bg-white-100 small-img-grid with-pattern px-15 py-30${
          module?.extraClass ? " " + module.extraClass : ""
        }`}
      >
        <div className="container-fluid category-listing py-75 lgscreen:py-30 ">
          {searchData?.length === 0 ? (
            <div className="w-[856px] m-auto text-center lgscreen:w-full px-20 content fade-ani">
              <div className="title-black">
                <h3>Can't find what you're looking for?</h3>
              </div>
              <p className="">
                Please try a different search term or return to our homepage.
              </p>
              <Link to="/" className="btn btn-border mt-20">
                Go Back Home
              </Link>
            </div>
          ) : (
            <>
              <div className="pt-40 pb-40 lg:mx-minus-30 mx-0 lg:px-15">
                {searchData.some(item => item.type === "WpEatDrink") && (
                  <p className="font-ositalic text-charcoal text-16">
                    Eat & Drink
                  </p>
                )}
              </div>
              <div className="flex flex-wrap lg:mx-minus-30 mx-0 gap-y-14">
                {searchData?.length > 0 &&
                  searchData
                    .slice(0, next)
                    .filter(item => item.type === "WpEatDrink")
                    .map(item => (
                      <div
                        key={uuidv4()}
                        className={`lg:w-4/12 w-full lg:px-15 px-0 fade-ani ${
                          item.title == "Guest Enquiry" ? "hidden" : ""
                        }`}
                      >
                        <div>
                          {item.featuredImage ? (
                            <ImageOpt
                              imgData={item.featuredImage?.node.mediaItemUrl}
                              imgAlt={item.featuredImage?.node?.altText}
                              imgClass="img relative w-[500px] h-[300px] object-cover"
                              width={1500}
                              height={1500}
                            />
                          ) : (
                            <img
                              src="/images/Hero.jpg"
                              className="img relative w-[500px] h-[300px] object-cover"
                            />
                          )}
                          <div className="ig-info p-30 lgsccreen:p-15">
                            {item.type === "WpEatDrink" && (
                              <span className="text-12 text-black-500 font-400 uppercase leading-22 mb-10 inline-block font-preheaders">
                                Eat & Drink
                              </span>
                            )}

                            <div className="title-black">
                              {item?.title && (
                                <h6 className="">{item.title}</h6>
                              )}

                              <div className="content">
                                {parse(item.excerpt && item.excerpt)}
                              </div>

                              {item?.uri && (
                                <div className="btn-custom flex flex-wrap items-center space-x-4 mt-20 ">
                                  <Link
                                    className="btn btn-border block smscreen2:hidden"
                                    to="/book-a-table/"
                                  >
                                    Book Now
                                  </Link>
                                  <Link
                                    to={item.uri}
                                    className="button btn-red-border underline"
                                  >
                                    View
                                  </Link>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
              </div>
              <div className="pt-40 pb-40 lg:mx-minus-30 mx-0 lg:px-15">
                <p className="font-ositalic text-charcoal text-16">
                  Other results
                </p>
              </div>
              <div className="flex flex-wrap lg:mx-minus-30 mx-0 gap-y-14">
                {searchData?.length > 0 &&
                  searchData.slice(0, next).map(item => (
                    <div className="lg:w-4/12 w-full px-20 lgscreen:px-0">
                      <div className="border-1 border-charcoal rounded-2 py-50 px-60 lgscreen:p-20">
                        {item.type === "WpEatDrink" && (
                          <span className="text-12 text-black-500 font-400 uppercase leading-22 mb-10 inline-block font-preheaders">
                            Eat & Drink
                          </span>
                        )}

                        {item.type === "WpPost" && (
                          <span className="text-12 text-black-500 font-400 uppercase leading-22 mb-10 inline-block font-preheaders">
                            Blogs
                          </span>
                        )}

                        {item.type === "WpPage" && (
                          <span className="text-12 text-black-500 font-400 uppercase leading-22 mb-10 inline-block font-preheaders">
                            KOVE Collection
                          </span>
                        )}
                        {item?.title && <h5>{item.title}</h5>}
                        {item?.excerpt && (
                          <div className="content pt-15">
                            {parse(item.excerpt)}
                          </div>
                        )}
                        {item?.uri && (
                          <div className="btn-custom flex flex-wrap items-center space-x-4 mt-20 ">
                            <Link
                              to={item.uri}
                              className="button btn-red-border underline"
                            >
                              View
                            </Link>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </section>
    </>
  )
}
export default SearchListing
